export enum AvailabilityStatusEnum {
  /** @deprecated **/
  Readily = 'readily',
  /** @deprecated **/
  AfterDownload = 'after-download',
  /** @deprecated **/
  No = 'no',
  Unknown = 'unknown',
  Unavailable = "unavailable",
  Downloadable = "downloadable",
  Downloading = "downloading",
  Available = "available",
}
